(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lohan-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript && document.currentScript.closest('.lohan-foot');
    const targets = document.querySelectorAll('.lohan-foot .lf-reveal');
    if (!('IntersectionObserver' in window) || !targets.length) {
      targets.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach((el) => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lohan-loja-fisica"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(c) {
    if (c.dataset.lojaReady) return; c.dataset.lojaReady = '1';
    var track = c.querySelector('[data-loja-track]');
    var dots = Array.prototype.slice.call(c.querySelectorAll('[data-loja-dot]'));
    var prev = c.querySelector('[data-loja-prev]');
    var next = c.querySelector('[data-loja-next]');
    if (!track) return;
    function step() { return track.clientWidth; }
    function go(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    function current() { return Math.round(track.scrollLeft / step()); }
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.lojaDot, 10)); }); });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = current();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      });
    });

    // autoplay (pausa no hover/foco/aba oculta; respeita prefers-reduced-motion)
    var slides = track.children.length;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides > 1 && !reduce) {
      var timer = null;
      var play = function () { stop(); timer = setInterval(function () { var n = current() + 1; if (n >= slides) n = 0; go(n); }, 5500); };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { c.addEventListener(ev, stop, { passive: true }); });
      ['pointerleave', 'focusout'].forEach(function (ev) { c.addEventListener(ev, play); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { play(); } });
      play();
    }
  }
  function run() { document.querySelectorAll('[data-loja-carousel]').forEach(init); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lohan-marcas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MAX_GROUPS = 24;

    // velocidade da etiqueta (segundos) cacheada uma vez — vira px/s constante
    function speedBase(marquee) {
      if (!marquee.dataset.speedBase) {
        var v = parseFloat(getComputedStyle(marquee).getPropertyValue('--marcas-speed')) || 42;
        marquee.dataset.speedBase = v;
      }
      return parseFloat(marquee.dataset.speedBase);
    }

    function build(marquee) {
      if (REDUCE) return;
      var track = marquee.querySelector('.lohan-marquee__track');
      if (!track) return;
      var base =
        track.querySelector('.lohan-marquee__group:not([aria-hidden])') ||
        track.querySelector('.lohan-marquee__group');
      if (!base) return;

      // garante o modo nowrap antes de medir (largura real de uma linha)
      marquee.dataset.marqueeReady = '1';

      var viewport = marquee.offsetWidth || window.innerWidth || 1200;
      var groupWidth = base.getBoundingClientRect().width || base.scrollWidth || 1;
      if (groupWidth < 1) return;

      // nada mudou desde o último cálculo? evita resetar a animação à toa
      var prevGw = parseFloat(marquee.dataset.gw || '0');
      var prevVw = parseFloat(marquee.dataset.vw || '0');
      if (
        marquee.dataset.built === '1' &&
        Math.abs(groupWidth - prevGw) < 1.5 &&
        Math.abs(viewport - prevVw) < 1.5
      ) {
        return;
      }
      marquee.dataset.gw = groupWidth;
      marquee.dataset.vw = viewport;
      marquee.dataset.built = '1';

      // remove clones de um cálculo anterior (recálculo em resize)
      var existing = track.querySelectorAll('.lohan-marquee__group');
      for (var k = 0; k < existing.length; k++) {
        if (existing[k] !== base) track.removeChild(existing[k]);
      }

      // CHAVE DO LOOP PERFEITO: cada METADE da faixa (o trecho que o -50%
      // percorre) precisa cobrir a viewport com 1 grupo INTEIRO de folga,
      // assim nunca sobra vão branco antes de reiniciar.
      var half = Math.ceil(viewport / groupWidth) + 1;
      var needed = half * 2; // par por construção -> emenda do -50% sempre alinha
      if (needed < 2) needed = 2;
      if (needed > MAX_GROUPS) needed = MAX_GROUPS;

      var frag = document.createDocumentFragment();
      for (var i = 1; i < needed; i++) {
        var clone = base.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        var ids = clone.querySelectorAll('[id]');
        for (var j = 0; j < ids.length; j++) ids[j].removeAttribute('id');
        frag.appendChild(clone);
      }
      track.appendChild(frag);

      // velocidade constante (px/s) — independe de quantos grupos foram criados
      var halfWidth = (needed / 2) * groupWidth;
      var pxPerSec = 1700 / speedBase(marquee); // ~40 px/s no padrão (42)
      var duration = Math.max(10, halfWidth / pxPerSec);
      marquee.style.setProperty('--marcas-speed', duration.toFixed(2) + 's');
    }

    function buildAll() {
      var list = document.querySelectorAll('.lohan-marquee');
      for (var i = 0; i < list.length; i++) build(list[i]);
    }

    // recalcula só quando a LARGURA muda (ignora resize de altura no mobile)
    var rt;
    var lastW = window.innerWidth;
    function onResize() {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(rt);
      rt = setTimeout(buildAll, 200);
    }

    function start() {
      buildAll();
      // remede após imagens/fontes assentarem (medida precisa)
      window.addEventListener('load', buildAll, { once: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(buildAll).catch(function () {});
      }
      window.addEventListener('resize', onResize);
    }

    if (document.readyState !== 'loading') {
      start();
    } else {
      document.addEventListener('DOMContentLoaded', start);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lohan-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ICONS={
   venus:'<circle cx="12" cy="8.5" r="5"/><path d="M12 13.5v7M9 17.5h6"/>',
   mars:'<circle cx="10" cy="14" r="5"/><path d="M14.5 9.5 20 4M15 4h5v5"/>',
   duo:'<circle cx="9.5" cy="12" r="5"/><circle cx="14.5" cy="12" r="5"/>',
   spark:'<path d="M12 3l1.7 6.3L20 11l-6.3 1.7L12 19l-1.7-6.3L4 11l6.3-1.7z"/>',
   drop:'<path d="M12 3.5s5.5 6.5 5.5 10.5a5.5 5.5 0 0 1-11 0c0-4 5.5-10.5 5.5-10.5z"/>',
   flower:'<path d="M12 21v-9"/><path d="M12 12c0-4-2.4-6.5-5-7 0 3 1 6 5 7zM12 12c0-4 2.4-6.5 5-7 0 3-1 6-5 7zM12 12c0-3.4 0-6 0-8 0 2 0 4.6 0 8z"/>',
   flame:'<path d="M12 3c3 4 4.5 6 4.5 9.5a4.5 4.5 0 0 1-9 0c0-1.7.7-2.8 1.7-3.8.2 1.5 1 2.1 1.6 2.3.7-2.5-1.4-4.7.2-8z"/>',
   tree:'<path d="M12 21v-4"/><path d="M12 3 7.5 11h9zM12 8l-3.5 6h7z"/>',
   wave:'<path d="M3 9c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/><path d="M3 15c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>',
   pod:'<path d="M12 3c-1.4 0-2 1.3-2 4v9c0 2 .9 3 2 3s2-1 2-3V7c0-2.7-.6-4-2-4z"/>',
   smoke:'<path d="M10 21c-1-2 1-3 1-5s-2-3-1-5 .6-3 0-4M14.5 21c-1-2 1-3 1-5s-2-3-1-5"/>',
   cherry:'<circle cx="8" cy="17" r="3"/><circle cx="16" cy="16" r="3"/><path d="M11 15 13.5 5M14 13.5 13.5 5M13.5 5c.2-1.5 1.7-2 3.3-1.3"/>',
   rings:'<ellipse cx="12" cy="12" rx="8.2" ry="5"/><ellipse cx="12" cy="12" rx="4.6" ry="2.8"/><circle cx="12" cy="12" r="1"/>',
   citrus:'<circle cx="12" cy="12" r="8.5"/><path d="M12 12V3.5M12 12l7.4-3M12 12l6.6 5.4M12 12v8.5M12 12 5 17.4M12 12 4.6 9"/>',
   sun:'<circle cx="12" cy="12" r="4"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>',
   moon:'<path d="M20 14.4A8 8 0 1 1 9.6 4 6.5 6.5 0 0 0 20 14.4z"/>',
   glass:'<path d="M7 4.5h10l-5 8zM12 12.5v6M9 18.5h6"/>',
   loop:'<path d="M4 12a4 4 0 0 1 8 0 4 4 0 0 0 8 0 4 4 0 0 0-8 0 4 4 0 0 1-8 0z"/>',
   vial:'<path d="M10 3.5h4M11 3.5v3l-2 3v8.5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9.5l-2-3v-3"/><path d="M9.2 13h5.6"/>',
   coin:'<circle cx="12" cy="12" r="8.5"/><path d="M14.6 9.4c-.8-.9-2-1.2-3-.9-1.2.3-1.5 1.6-.5 2.2.7.4 1.8.5 2.6 1 .9.5.9 1.8-.3 2.2-1.1.4-2.3 0-3-.8M12 7v1.4M12 15v1.4"/>',
   cards:'<rect x="4" y="8.5" width="12" height="9" rx="1.6"/><rect x="8.5" y="5.5" width="12" height="9" rx="1.6"/>',
   check:'<polyline points="4 12 9 17 20 6"/>'
  };
  function ic(n){return '<svg viewBox="0 0 24 24" aria-hidden="true">'+(ICONS[n]||'')+'</svg>';}
  var FLACON='<svg viewBox="0 0 64 64" class="lq-flacon"><path d="M24 7h16v6H24zM27 13v6h10v-6M18 24q0-5 6-5h16q6 0 6 5v28q0 5-5 5H23q-5 0-5-5z"/></svg>';
  var FAMVAR={doce:'--lq-doce',floral:'--lq-floral',ambar:'--lq-ambar',amadeirado:'--lq-amadeirado',fresco:'--lq-fresco'};
  var FAMTXT={doce:'Doce / Gourmand',floral:'Floral',ambar:'Âmbar / Oriental',amadeirado:'Amadeirado',fresco:'Fresco / Aromático'};

  var QUESTIONS=[
   {id:'genero',q:'Pra quem é essa fragrância?',hint:'Escolha uma opção.',multi:false,opts:[
     {v:'feminino',t:'Feminino',ic:'venus'},{v:'masculino',t:'Masculino',ic:'mars'},
     {v:'unissex',t:'Unissex',ic:'duo'},{v:'qualquer',t:'Tanto faz',d:'me surpreenda',ic:'spark'}]},
   {id:'familia',q:'Que atmosfera combina com você?',hint:'Pode escolher mais de uma.',multi:true,opts:[
     {v:'doce',t:'Doce e envolvente',d:'baunilha, caramelo',ic:'drop'},
     {v:'floral',t:'Floral e delicado',d:'flores, frutas',ic:'flower'},
     {v:'ambar',t:'Quente e marcante',d:'âmbar, oud, resinas',ic:'flame'},
     {v:'amadeirado',t:'Amadeirado e elegante',d:'madeira, especiarias',ic:'tree'},
     {v:'fresco',t:'Fresco e leve',d:'cítrico, aquático',ic:'wave'}]},
   {id:'ocasiao',q:'Quando você mais vai usar?',hint:'Escolha uma opção.',multi:false,opts:[
     {v:'dia',t:'Dia a dia',d:'discreto e versátil',ic:'sun'},
     {v:'noite',t:'Noite & encontros',d:'marcante e sedutor',ic:'moon'},
     {v:'especial',t:'Ocasiões especiais',d:'presença máxima',ic:'glass'},
     {v:'sempre',t:'Pra tudo',d:'um coringa',ic:'loop'}]},
   {id:'preco',q:'Como prefere começar?',hint:'Sem compromisso — só pra calibrar.',multi:false,opts:[
     {v:'testar',t:'Quero testar antes',d:'me mostre em decant',ic:'vial'},
     {v:'ate400',t:'Até R$ 400',ic:'coin'},
     {v:'400a700',t:'R$ 400 a R$ 700',ic:'cards'},
     {v:'sem',t:'Sem limite',d:'quero o ideal',ic:'spark'}]}
  ];

  function broadFamily(tags){
    for(var i=0;i<tags.length;i++){var m=/^familia:(\w+)/.exec(tags[i]);if(m)return m[1];}
    return null;
  }
  function tagVal(tags,prefix){
    for(var i=0;i<tags.length;i++){if(tags[i].indexOf(prefix)===0)return tags[i].slice(prefix.length);}
    return null;
  }
  function notasFromFamily(f){
    return {doce:['baunilha','frutas'],floral:['flores','frutas'],ambar:['oud','especiarias'],
            amadeirado:['madeira','especiarias'],fresco:['citricos','aquatico']}[f]||[];
  }
  function intFromFamily(f){return {ambar:'forte',doce:'forte',amadeirado:'media',floral:'media',fresco:'leve'}[f]||'media';}
  function lvl(i){return {leve:0,media:1,forte:2}[i];}
  function famLabel(f){return {doce:'doce',floral:'floral',ambar:'marcante',amadeirado:'amadeirado',fresco:'fresco'}[f]||f;}
  function occWhy(o){return {dia:'ideal pro dia',noite:'ideal pra noite',especial:'presença máxima',sempre:'coringa'}[o]||'';}
  function mono(b){return (b||'L').split(' ').map(function(x){return x[0];}).join('').slice(0,2).toUpperCase();}
  function money(v){return 'R$ '+v.toFixed(2).replace('.',',');}

  function mapProduct(pr){
    var tags=pr.tags||[];
    var fam=broadFamily(tags);
    var g=tagVal(tags,'genero:')||'unissex';
    var dec=tagVal(tags,'decant:')||'sem';
    var prices=(pr.variants||[]).map(function(v){return parseFloat(v.price);}).filter(function(n){return !isNaN(n);});
    var price=prices.length?Math.max.apply(null,prices):0;
    var img=(pr.images&&pr.images[0])?pr.images[0].src:null;
    return {h:pr.handle,t:pr.title,b:pr.vendor,g:g,fam:fam,famtxt:fam?FAMTXT[fam]:'',
      notas:notasFromFamily(fam),int:intFromFamily(fam),dec:dec,
      mv:tags.indexOf('destaque:mais-vendido')>=0,p:price,img:img,
      url:(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'products/'+pr.handle};
  }

  // Faixas calibradas pelo acervo (mediana ~R$400; abaixo de R$300 só decants):
  // até 400 cobre ~62% do catálogo com todas as famílias; 400–700 são as grifes.
  function budgetCap(A){return A.preco==='ate400'?400:(A.preco==='400a700'?700:null);}

  // Máximo de pontos possível DADAS as respostas do usuário — base da afinidade
  // absoluta (score/maxScore). Manter em sincronia com score().
  function maxScore(A){
    var m=8; // sinais menores sempre possíveis: mais vendido (5) + dá pra provar em decant (3)
    if(A.familia&&A.familia.length)m+=46;
    if(A.genero&&A.genero!=='qualquer')m+=24;
    if(A.ocasiao){m+=16;if(A.ocasiao==='noite'||A.ocasiao==='dia')m+=6;}
    if(A.preco==='testar')m+=22;
    else if(A.preco==='ate400'||A.preco==='400a700')m+=12;
    return m;
  }

  function score(p,A){
    var s=0,why=[],clash=false,over=false;
    // 1) Atmosfera / família olfativa — eixo principal
    if(A.familia&&A.familia.length){
      if(A.familia.indexOf(p.fam)>=0){s+=46;why.push(famLabel(p.fam));}
      else{s-=12;} // fora da atmosfera escolhida: penaliza (não elimina)
    }
    // 2) Gênero — oposto explícito desclassifica o destaque principal
    if(A.genero&&A.genero!=='qualquer'){
      if(A.genero===p.g)s+=24;
      else if(p.g==='unissex'){s+=14;why.push('unissex');}
      else{s-=30;clash=true;}
    }
    // 3) Ocasião -> intensidade desejada
    if(A.ocasiao){
      var occ={dia:'leve',noite:'forte',especial:'forte',sempre:'media'}[A.ocasiao]||'media';
      if(p.int===occ){s+=16;why.push(occWhy(A.ocasiao));}
      else if(Math.abs(lvl(p.int)-lvl(occ))===1)s+=7;
      else s-=4;
      if(A.ocasiao==='noite'&&(p.fam==='ambar'||p.fam==='doce'))s+=6;
      if(A.ocasiao==='dia'&&p.fam==='fresco')s+=6;
    }
    // 4) Orçamento — desclassificatório p/ destaque (filtro em compute), além dos pontos
    var hasDec=(p.dec==='com'||p.dec==='somente');
    var cap=budgetCap(A);
    if(cap&&p.p&&p.p>cap)over=true;
    if(A.preco==='testar'){if(hasDec){s+=22;why.push('tem decant');}else{s-=4;}}
    else if(A.preco==='ate400'){if(p.p&&p.p<=400){s+=12;why.push('no seu orçamento');}else if(p.p)s-=14;}
    else if(A.preco==='400a700'){if(p.p>=400&&p.p<=700){s+=12;why.push('na sua faixa');}else if(p.p&&p.p<400){s+=4;}else if(p.p){s-=6;}}
    // 5) Sinais menores reais
    if(hasDec&&A.preco!=='testar')s+=3;
    if(p.mv){s+=5;why.push('mais vendido');}
    var uniq=[];why.forEach(function(w){if(w&&uniq.indexOf(w)<0)uniq.push(w);});
    return {s:s,why:uniq,dec:hasDec,clash:clash,over:over};
  }

  function init(root){
    if(root.dataset.lqReady)return; root.dataset.lqReady='1';
    var coll=root.dataset.collection||'all';
    var ctaUrl=root.dataset.cta||'/collections/all';
    var screens={};
    root.querySelectorAll('.lq-screen').forEach(function(el){screens[el.dataset.screen]=el;});
    var answers={},qi=0,PRODUCTS=null,loadingErr=false;

    // prefetch do catálogo (ao vivo => sempre atual)
    var rootPath=(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/');
    function fetchAll(){
      var acc=[],page=1;
      function go(){
        return fetch(rootPath+'collections/'+coll+'/products.json?limit=250&page='+page,{headers:{Accept:'application/json'}})
          .then(function(r){return r.ok?r.json():Promise.reject(r.status);})
          .then(function(d){
            var list=(d&&d.products)||[];
            acc=acc.concat(list);
            if(list.length===250&&page<6){page++;return go();}
            return acc;
          });
      }
      return go();
    }
    var loadP=fetchAll().then(function(list){
      PRODUCTS=list.map(mapProduct).filter(function(p){return p.fam;});
      return PRODUCTS;
    }).catch(function(){loadingErr=true;PRODUCTS=[];return [];});

    function prefersReducedMotion(){
      return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function showScreen(id){
      Object.keys(screens).forEach(function(k){screens[k].classList.remove('lq-on');});
      screens[id].classList.add('lq-on');
      var behavior=prefersReducedMotion()?'auto':'smooth';
      try{root.scrollIntoView({behavior:behavior,block:'start'});}catch(e){}
    }
    // Move o foco para o cabeçalho da nova tela (acessibilidade de teclado/leitor).
    function focusHeading(el){
      if(!el)return;
      var h=el.querySelector('.lq-q, .lq-h1');
      if(h){try{h.focus();}catch(e){}}
    }
    function valid(Q){var a=answers[Q.id];return Q.multi?(a&&a.length):!!a;}

    function renderQ(){
      var Q=QUESTIONS[qi];
      // single-select => radiogroup/radio + aria-checked; multi-select => group + aria-pressed (toggle).
      var optRole=Q.multi?'':' role="radio"';
      var opts=Q.opts.map(function(o){
        var sel=answers[Q.id];var on=Q.multi?(sel||[]).indexOf(o.v)>=0:sel===o.v;
        var ariaState=Q.multi?(' aria-pressed="'+(on?'true':'false')+'"'):(' aria-checked="'+(on?'true':'false')+'"');
        return '<button type="button"'+optRole+ariaState+' class="lq-opt'+(on?' lq-sel':'')+'" data-pick="'+o.v+'">'+
          '<span class="lq-opt__ic">'+ic(o.ic)+'</span>'+
          '<span class="lq-opt__tx"><span class="lq-opt__t">'+o.t+'</span>'+(o.d?'<span class="lq-opt__d">'+o.d+'</span>':'')+'</span>'+
          '<span class="lq-opt__chk">'+ic('check')+'</span></button>';
      }).join('');
      var groupRole=Q.multi?'group':'radiogroup';
      screens.quiz.innerHTML=
        '<div class="lq-prog"><span class="lq-prog__n"><b>0'+(qi+1)+'</b> / 0'+QUESTIONS.length+'</span>'+
        '<span class="lq-prog__track"><span class="lq-prog__f" style="width:'+((qi+1)/QUESTIONS.length*100)+'%"></span></span></div>'+
        '<h2 class="lq-q" id="lq-q-'+qi+'" tabindex="-1">'+Q.q+'</h2><p class="lq-qhint">'+Q.hint+'</p>'+
        '<div class="lq-opts" role="'+groupRole+'" aria-labelledby="lq-q-'+qi+'">'+opts+'</div>'+
        '<div class="lq-nav"><button type="button" class="lq-btn lq-btn--g" data-action="prev"'+(qi===0?' style="visibility:hidden"':'')+'>‹ Voltar</button>'+
        '<button type="button" class="lq-btn lq-btn--p" data-action="next"'+(valid(Q)?'':' disabled')+'>'+(qi===QUESTIONS.length-1?'Ver minha curadoria':'Continuar')+'</button></div>';
    }
    function pick(v){
      var Q=QUESTIONS[qi];
      if(Q.multi){answers[Q.id]=answers[Q.id]||[];var i=answers[Q.id].indexOf(v);if(i>=0)answers[Q.id].splice(i,1);else answers[Q.id].push(v);}
      else answers[Q.id]=v;
      renderQ();
    }

    function famGrad(f){return 'linear-gradient(150deg, var('+(FAMVAR[f]||'--lq-gold')+'), #241f1a)';}
    function imgStyle(p,grad){return p.img?('background-image:url('+p.img+')'):('background:'+grad);}

    function compute(){
      screens.results.innerHTML='<div class="lq-loading">Montando sua curadoria…</div>';
      showScreen('results');
      loadP.then(function(){
        if(!PRODUCTS||!PRODUCTS.length){
          screens.results.innerHTML='<p class="lq-res-sub">Não consegui carregar o acervo agora. <button type="button" class="lq-btn lq-btn--g" data-action="start">Tentar de novo</button></p>';
          return;
        }
        var ranked=PRODUCTS.map(function(p){var r=score(p,answers);r.p=p;return r;}).sort(function(a,b){return b.s-a.s;});

        // Afinidade ABSOLUTA: pontos do produto / máximo possível para estas
        // respostas. Varia de verdade por produto (nada de 99% pra todo mundo).
        var maxS=maxScore(answers);
        function aff(r){return Math.max(40,Math.min(98,Math.round(Math.max(0,r.s)/maxS*100)));}

        // Orçamento é desclassificatório: o destaque e a quase totalidade do
        // grid respeitam a faixa; no máximo 1 acima entra como exceção sinalizada.
        var within=ranked.filter(function(r){return !r.over;});
        var overs=ranked.filter(function(r){return r.over;});
        if(!within.length){within=ranked;overs=[];}

        // Destaque principal: dentro do orçamento e sem conflito de gênero
        var heroPool=within.filter(function(r){return !r.clash;});
        if(!heroPool.length)heroPool=within;
        var hero=heroPool[0];

        // Grid: sem conflito de gênero e com afinidade mínima — melhor 3 boas
        // recomendações do que 5 fracas vendidas como "combinam com você".
        var rest=within.filter(function(r){return r!==hero&&!r.clash&&aff(r)>=55;}).slice(0,5);
        if(!rest.length)rest=within.filter(function(r){return r!==hero&&!r.clash;}).slice(0,3);
        var bestOver=overs.filter(function(r){return !r.clash;})[0];
        if(bestOver&&aff(bestOver)>=70){
          rest=rest.slice(0,4).concat([bestOver]);
          bestOver.why.unshift('acima da sua faixa');
        }
        var chips=function(r,n){return r.why.slice(0,n||4).map(function(w,i){return '<span class="lq-chip'+(i===0?' lq-chip--gold':'')+'">'+w+'</span>';}).join('');};
        var profile=[];
        if(answers.genero&&answers.genero!=='qualquer')profile.push(answers.genero);
        (answers.familia||[]).forEach(function(f){profile.push(famLabel(f));});
        var occP={dia:'para o dia a dia',noite:'para a noite',especial:'para ocasiões especiais',sempre:'versátil'}[answers.ocasiao];
        if(occP)profile.push(occP);
        if(answers.preco==='ate400')profile.push('até R$ 400');
        else if(answers.preco==='400a700')profile.push('entre R$ 400 e R$ 700');

        var a=aff(hero),circ=2*Math.PI*31,off=circ*(1-a/100);
        var hp=hero.p;
        var heroHtml='<article class="lq-hero"><div class="lq-hero__img" style="'+imgStyle(hp,famGrad(hp.fam))+'">'+(hp.img?'':FLACON+'<span class="lq-hero__mono">'+mono(hp.b)+'</span>')+'</div>'+
          '<div class="lq-hero__b"><span class="lq-hero__brand">'+hp.b+'</span><h3 class="lq-hero__name">'+hp.t+'</h3>'+
          '<span class="lq-fam"><i class="lq-fam__dot" style="background:var('+FAMVAR[hp.fam]+')"></i>'+hp.famtxt+'</span>'+
          '<div class="lq-hero__row"><div class="lq-ring"><svg width="72" height="72" viewBox="0 0 72 72"><circle cx="36" cy="36" r="31" stroke="var(--lq-border)" stroke-width="4" fill="none"/><circle cx="36" cy="36" r="31" stroke="var(--lq-gold)" stroke-width="4" fill="none" stroke-linecap="round" stroke-dasharray="'+circ+'" stroke-dashoffset="'+off+'"/></svg><span class="lq-ring__t">'+a+'%<small>afinidade</small></span></div>'+
          '<div class="lq-why">'+chips(hero)+'</div></div>'+
          '<div class="lq-hero__row" style="margin-top:18px">'+(hp.p?'<span class="lq-price">'+money(hp.p)+'</span>':'')+'</div>'+
          '<div class="lq-cta"><a class="lq-buy" href="'+hp.url+'">Ver perfume</a>'+(hero.dec?'<a class="lq-dec" href="'+hp.url+'">Experimentar em decant</a>':'')+'</div></div></article>';

        var cards=rest.map(function(r,i){var p=r.p;
          return '<article class="lq-pc" style="animation-delay:'+(0.08*(i+1))+'s"><div class="lq-pc__img" style="'+imgStyle(p,famGrad(p.fam))+'"><span class="lq-pc__aff">'+aff(r)+'% match</span>'+(p.img?'':mono(p.b))+'</div>'+
            '<div class="lq-pc__b"><span class="lq-pc__brand">'+p.b+'</span><h3 class="lq-pc__name">'+p.t+'</h3>'+
            '<span class="lq-fam"><i class="lq-fam__dot" style="background:var('+FAMVAR[p.fam]+')"></i>'+p.famtxt+'</span>'+
            '<div class="lq-pc__why">'+chips(r,3)+'</div>'+
            (p.p?'<span class="lq-pc__price">'+money(p.p)+'</span>':'')+
            '<div class="lq-pc__cta"><a class="lq-buy" href="'+p.url+'">Ver</a>'+(r.dec?'<a class="lq-dec" href="'+p.url+'">Decant</a>':'')+'</div></div></article>';
        }).join('');

        screens.results.innerHTML=
          '<div class="lq-eyebrow">Sua curadoria</div><h2 class="lq-h1" tabindex="-1">Encontramos seus pares</h2>'+
          '<p class="lq-res-sub">Com base num perfil <b>'+(profile.join(', ')||'versátil')+'</b>'+(answers.preco==='testar'?', priorizando opções para você <b>experimentar em decant</b>':'')+'. Tudo selecionado do acervo atual da loja.</p>'+
          '<div class="lq-lbl">Seu par perfeito</div>'+heroHtml+
          '<div class="lq-lbl">Também combinam com você</div><div class="lq-grid">'+cards+'</div>'+
          '<div class="lq-center"><button type="button" class="lq-btn lq-btn--o" data-action="start">Refazer o quiz</button><a class="lq-btn lq-btn--p" href="'+ctaUrl+'">Ver acervo completo</a></div>';
        focusHeading(screens.results);
      });
    }

    root.addEventListener('click',function(e){
      var pickEl=e.target.closest('[data-pick]');
      if(pickEl&&root.contains(pickEl)){pick(pickEl.getAttribute('data-pick'));return;}
      var act=e.target.closest('[data-action]');
      if(!act||!root.contains(act))return;
      var a=act.getAttribute('data-action');
      if(a==='start'){answers&&Object.keys(answers).forEach(function(k){delete answers[k];});qi=0;showScreen('quiz');renderQ();focusHeading(screens.quiz);}
      else if(a==='next'){if(!valid(QUESTIONS[qi]))return;if(qi<QUESTIONS.length-1){qi++;renderQ();focusHeading(screens.quiz);}else compute();}
      else if(a==='prev'){if(qi>0){qi--;renderQ();focusHeading(screens.quiz);}}
    });
  }

  function run(){document.querySelectorAll('.lohan-quiz').forEach(init);}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lohan-rastreio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function sanitize(value) {
      return (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    function wire(form) {
      if (form.__lohanRastreioWired) return;
      form.__lohanRastreioWired = true;

      var input = form.querySelector('.lohan-rastreio__input');
      var hint = form.querySelector('.lohan-rastreio__hint');
      var defaultHint = hint ? hint.textContent : '';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var code = sanitize(input.value);

        if (code.length < 8) {
          if (hint) {
            hint.textContent = 'Confira o código — ele costuma ter 13 caracteres, como AA123456789BR.';
          }
          input.focus();
          return;
        }

        var base = form.getAttribute('data-correios-base') ||
          'https://rastreamento.correios.com.br/app/index.php?objetos=';

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(function () {});
        }

        window.open(base + encodeURIComponent(code), '_blank', 'noopener');

        if (hint) {
          hint.textContent = 'Abrimos os Correios numa nova aba e copiamos seu código. Se o campo estiver vazio, é só colar.';
        }
      });

      input.addEventListener('input', function () {
        if (hint && hint.textContent !== defaultHint) {
          hint.textContent = defaultHint;
        }
      });
    }

    function init() {
      document.querySelectorAll('.lohan-rastreio__card').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
